var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColorfulStarOnGraph(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.06 7.94L11 7L13.06 6.06L14 4L14.94 6.06L17 7L14.94 7.94L14 10L13.06 7.94ZM3 12L3.94 9.94L6 9L3.94 8.06L3 6L2.06 8.06L0 9L2.06 9.94L3 12ZM7.5 7L8.59 4.59L11 3.5L8.59 2.41L7.5 0L6.41 2.41L4 3.5L6.41 4.59L7.5 7ZM3.5 18.5L9.5 12.49L13.5 16.49L22 6.93L20.59 5.52L13.5 13.49L9.5 9.49L2 17L3.5 18.5Z",
    fill: "url(#paint0_linear_19313_2318)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19313_2318",
    x1: -0.000342606,
    y1: 18.4999,
    x2: 18.2254,
    y2: -3.17406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D6AD0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9D7E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorfulStarOnGraph);
export default __webpack_public_path__ + "static/media/colorful-star-on-graph.d94f1b5cee60d73e7878f2c09f5928ad.svg";
export { ForwardRef as ReactComponent };